import { Component, OnInit, TemplateRef, ViewChild, ViewEncapsulation, Inject, Injectable } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { NxDialogService, NxModalRef } from '@aposin/ng-aquila/modal';
import { NxDateAdapter, NxDatepickerIntl, NX_DATE_LOCALE } from '@aposin/ng-aquila/datefield';
import { CallmebackService } from '@core/services/callmeback.service';
import { CommonService } from '@core/services/common.service';
import { CallMeBack } from '@shared/models/call-me-back';
import moment, { Moment } from 'moment';
import holidays from '../../../../../holidays.json';
import { Language } from '@shared/models/language';
import { LocaleService } from '@core/services/locale.service';
import { UserService } from '@core/services/user.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class MyIntl extends NxDatepickerIntl {
    constructor(private translateService: TranslateService) {
        super();
        this.switchToMonthViewLabel = this.translateService.instant('common.date.month-view');
        this.switchToMultiYearViewLabel = this.translateService.instant('common.date.date-view');
    }
}

@Component({
    selector: 'app-call-me-back',
    templateUrl: './call-me-back.component.html',
    styleUrls: ['./call-me-back.component.scss'],
    standalone: false
})
export class CallMeBackComponent implements OnInit {
    @ViewChild('template') templateRef: TemplateRef<any>;

    templateDialogRef: NxModalRef<any>;

    // form
    form: FormGroup;

    private startHour: number = 8;
    private startMinute: number = 0;
    private endHour: number = 18;

    private startHourWeekend: number = 9;
    private startMinuteWeekend: number = 0;
    private endHourWeekend: number = 17;

    private breakStart: string = '12';
    private breakStartMinute: string = '00';
    private breakEnd: string = '13';
    private breakEndMinute: string = '00';

    private granularity: number = 60;

    public hourData: Object = {};
    public hourDataArray: Array<string> = [];
    public formBEValid: boolean = false;

    constructor(
        private userService: UserService,
        private localeService: LocaleService,
        private commonService: CommonService,
        private callMeBackService: CallmebackService,
        public dialogService: NxDialogService,
        public dateAdapter: NxDateAdapter<Moment>,
        private translateService: TranslateService,
        @Inject(NX_DATE_LOCALE) private nxDateLocale: string,
        @Inject(NxDatepickerIntl) private intl: NxDatepickerIntl,
    ) {

        this.userService.getLoggedUser().subscribe(() => {
            this.localeService.activeLanguage.subscribe(language => {
                this.changeLocaleDatePicker(this.LanguageMapper(language));
            });
        });

        this.translateService.get('common.date.month-view').subscribe( x => {
            this.intl.switchToMonthViewLabel = x;
        })

        this.translateService.get('common.date.date-view').subscribe( x => {
            this.intl.switchToMultiYearViewLabel = x;
        })

        translateService.onLangChange.subscribe(x => {
            let lang = this.localeService.languages.find(y => y.code.toLowerCase() == x.lang);
            if (lang && lang.iso) {
                intl.switchToMonthViewLabel = translateService.instant('common.date.month-view');
                intl.switchToMultiYearViewLabel = translateService.instant('common.date.date-view');
                this.nxDateLocale = lang.iso;
            }
        });
    }

    ngOnInit(): void {
        if (this.commonService.callMeBackOPenModalsubscription === undefined) {
            this.commonService.callMeBackOPenModalsubscription = this.commonService.callMeBackOPenModalFunction.subscribe(
                () => { this.openModal(); });
        }

        this.form = new FormGroup({
            date: new FormControl(''),
            hour: new FormControl('', Validators.required),
            agreement: new FormControl(true, Validators.requiredTrue),
        });

        this.form.get('hour').disable();
        this.generateTimeSlots();
    }

    timeBind() {
        this.generateTimeSlots();

        (!this.form.get('date').value && !this.form.get('date').invalid) ?
            this.form.get('hour').disable() : this.form.get('hour').enable();
    }

    private changeLocaleDatePicker(value) {
        this.dateAdapter.setLocale(value);
    }

    filterDate = (date: Moment): boolean => {
        // sem treba pre hour dotiahnut premennu endHour ktora je hore ako private a pripocitat k nej + 1,
        let DatetimeAfterLastSlot = moment(moment(), 'HH:mm');
        // weekend
        if (date.day() == 0 || date.day() == 6) {
            return false;
            // DatetimeAfterLastSlot.set({
            //     'hour': this.endHour + 1, // endHour + 1
            //     'minute': 0
            // });

        } else {
            DatetimeAfterLastSlot.set({
                'hour': this.endHourWeekend + 1, // endHourWeekend + 1
                'minute': 0
            });
        }

        if (!date.isAfter(moment(), 'day')) {
            return false;
        }

        // today date time after last time slot
        /*if (DatetimeAfterLastSlot.isBefore(moment(), 'minute')) {
          return false;
        }*/

        // history
        if (date.isBefore(moment(), 'day')) {
            return false;
        }

        // future bound
        if (date.isAfter(moment.now() + (90 * (1000 * 60 * 60 * 24)))) {
            return false;
        }

        // holidays
        for (const [dateHoliday, nameHoliday] of Object.entries(holidays)) {
            if (moment(moment(date.format('YYYY-MM-DD'))).isSame(moment(dateHoliday), 'day')) {
                return false;
            }
        }

        return true;
    };

    generateTimeSlots() {
        if (this.form.get('date').value == "" || this.form.get('date').invalid) {
            this.hourDataArray = [];
        } else {

            let formDate = this.form.get('date').value;
            // weekend
            if (formDate.day() == 0 || formDate.day() == 6) {
                this.hourData = {};
                let startMinute = this.startMinuteWeekend;

                for (var i = this.startHourWeekend - 1; i <= this.endHourWeekend; startMinute += this.granularity) {
                    let minute = '30';
                    if (startMinute % 60 == 0) {
                        minute = '00';
                        i++;
                        if (i == this.endHourWeekend) {
                            break;
                        }
                    }

                    let time = moment(moment(), 'HH:mm');
                    time.set({
                        'hour': i,
                        'minute': Number(minute)
                    });

                    // today history remove
                    if ((!this.form.get('date').value && time.isSameOrBefore(moment(), 'minute')) || (this.form.get('date').value && moment().isSame(this.form.get('date').value, 'day') && time.isSameOrBefore(moment(), 'minute'))) {
                        continue;
                    }

                    // lunch
                    if (Number(i.toString() + minute) >= Number(this.breakStart + this.breakStartMinute) && Number(i.toString() + minute) <= Number(this.breakEnd + this.breakEndMinute)) {
                        continue;
                    }

                    this.hourData[i.toString() + ":" + minute] = i.toString() + ":" + minute;
                }

                this.hourDataArray = Object.keys(this.hourData);
            }
            else // weekday
            {
                this.hourData = {};
                let startMinute = this.startMinute;

                for (var i = this.startHour - 1; i <= this.endHour; startMinute += this.granularity) {
                    let minute = '30';
                    if (startMinute % 60 == 0) {
                        minute = '00';
                        i++;
                        if (i == this.endHour) {
                            break;
                        }
                    }

                    let time = moment(moment(), 'HH:mm');
                    time.set({
                        'hour': i,
                        'minute': Number(minute)
                    });

                    // today history remove
                    if ((!this.form.get('date').value && time.isSameOrBefore(moment(), 'minute')) || (this.form.get('date').value && moment().isSame(this.form.get('date').value, 'day') && time.isSameOrBefore(moment(), 'minute'))) {
                        continue;
                    }

                    // lunch
                    if (Number(i.toString() + minute) >= Number(this.breakStart + this.breakStartMinute) && Number(i.toString() + minute) <= Number(this.breakEnd + this.breakEndMinute)) {
                        continue;
                    }

                    this.hourData[i.toString() + ":" + minute] = i.toString() + ":" + minute;
                }

                this.hourDataArray = Object.keys(this.hourData);
            }
        }
    }


    submit(event: Event) {
        event.preventDefault();

        let date = '';

        // date not valid
        if (this.form.value.date == "" || !this.form.value.date.isValid()) {
            this.form.get('date').setErrors({ valid: false });
        }
        // date is history
        else if (moment(this.form.value.date.format('MM-DD-YYYY')).isBefore(moment().format('MM-DD-YYYY'), 'day')) {
            this.form.get('date').setErrors({ history: true });
        }  // future bound
        else if (moment(this.form.value.date.format('MM-DD-YYYY')).isAfter(moment.now() + (90 * (1000 * 60 * 60 * 24)))) {
            this.form.get('date').setErrors({ future: true });
        }
        else {

            // holidays
            for (const [dateHoliday, nameHoliday] of Object.entries(holidays)) {
                if (moment(moment(this.form.value.date.format('YYYY-MM-DD'))).isSame(moment(dateHoliday), 'day')) {
                    this.form.get('date').setErrors({ holiday: true });
                }
            }

            // valid
            let d = this.form.value.date.date();
            let m = this.form.value.date.month() + 1;
            let y = this.form.value.date.year();

            date = d.toString() + '-' + m.toString() + '-' + y.toString();
        }

        let hour = this.form.value.hour;
        if (this.hourData[hour] == undefined) { // not in available time
            this.form.get('hour').setErrors({ valid: false });
        } else {

            let tmpHour = hour.split(':');
            // time has gone
            let time = moment(moment(), 'HH:mm');
            time.set({
                'hour': tmpHour[0],
                'minute': Number(tmpHour[1])
            });

            if ((!this.form.get('date').value && time.isSameOrBefore(moment(), 'minute')) || (this.form.get('date').value && moment().isSame(this.form.get('date').value, 'day') && time.isSameOrBefore(moment(), 'minute'))) {
                this.form.get('hour').setErrors({ history: true });
            }

        }

        // autovalid - must be true
        let agreement = this.form.value.agreement;
        if (agreement && this.form.valid) {

            let callMeBack = new CallMeBack();
            callMeBack.date = date;
            callMeBack.hour = hour;
            callMeBack.agreement = agreement;
            callMeBack.source = 'Šťastný život';

            this.callMeBackService.postCallMeBack(callMeBack).subscribe(res => {
                if (res && res.errors && Object.entries(res.errors).length > 0) {

                    for (const [key, value] of Object.entries(res.errors)) {
                        let err = {};
                        err[value] = true;
                        this.form.get(key).setErrors(err);
                    }

                } else {
                    this.formBEValid = true;
                }
            });
        }

    }

    openModal(): void {
        this.templateDialogRef = this.dialogService.open(this.templateRef, { showCloseIcon: true });
    }

    private LanguageMapper(language: Language) {
        if (language.code == 'SK') {
            return 'sk-SK';
        }

        return 'en-US';
    }
}
